import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

interface Props {
  className?: string
}

const Filters = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  // NOTE: this className is used in the LayoutWithFilters component
  const classnames = classNames('filters-component', className)

  return <div className={classnames}>{children}</div>
}

export const FiltersContent = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  const classnames = classNames('filters-component-content', className)

  return <div className={classnames}>{children}</div>
}

export default Filters
